import { render } from "./SlideOverComponent.vue?vue&type=template&id=97c964e2"
import script from "./SlideOverComponent.vue?vue&type=script&lang=js"
export * from "./SlideOverComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__